export class McRAIVideo {
  constructor(
    public id: string
  ) { }
}
